import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectNonFixedInstumentListResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_INSTRUMENT_LIST_RESPONSE);
        this.NonFixedInstrumentInfoList = [];
    }
}
export class NonFixedInstrumentInfo {
    constructor() {
        this.InstrDateSettingsList = null;
        this.ID = null;
        this.Name = null;
        this.InstrType = 0;
        this.GroupId = 0;
        this.ExchangeId = 0;
        this.Underlier = null;
        this.UnderlierUnderlier = null;
        this.PointSize = 0;
        this.UseOptionDescription = null;
        this.AllExpDateLoaded = true;
        this.AllContractsLoaded = true;
        this.SerieName = null;
        this.UnderlierID = null;
        this.Description = null;
        this.Routes = null;
        this.TradingExchange = null;
        this.MarketDataExchange = null;
        this.CountryId = -1;
        this.UnderlierDescr = null;
        this.UnderlierCountryId = null;
        this.UnderlierTradingExchange = null;
    }
    toString() {
        return this.Name || 'null';
    }
}
